import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { Flight } from '../../../../models/flight';

export interface SubStepOneModalState {
    permissionState: string;
    showNotificationMessage: boolean;
}

export interface SubStepOneModalProps {
    flight: Flight;
    isShowing: boolean;
    close: () => void;
    navigationFunc: (arg0: boolean, arg1: number) => void;
}

export default class SubStepOneModal extends React.Component<SubStepOneModalProps,
    SubStepOneModalState> {
    state: SubStepOneModalState;
    n: any = navigator;

    constructor(props: SubStepOneModalProps) {
        super(props);
        this.state = {
            showNotificationMessage: false,
            permissionState: '',
        };
        let n = navigator as any;
        let permissions = n.permissions;
        if (permissions === undefined || permissions == null) {
            this.state = Object.assign(this.state, {
                permissionState: 'denied',
            });
            this.state = Object.assign(this.state, {
                permissionState: 'blocked',
            });
        } else {
            n.permissions
                .query({name: 'notifications'})
                .then((permission: any) =>
                    Object.assign(this.state, {
                        permissionState: permission.state,
                    }),
                );
        }
    }

    render() {
        if (this.props.flight === undefined) {
            return null;
        }
        return (
            <Modal
                show={this.props.isShowing}
                size={'lg'}
                centered
                onHide={this.props.close}>
                <Modal.Header>
                    <Modal.Title className='w-100 text-center'>
                        Choose notification method
                    </Modal.Title>
                    <button
                        type='button'
                        style={{}}
                        onClick={this.props.close}
                        className='close'>
                        <span aria-hidden='true'>×</span>
                        <span className='sr-only'>Close</span>
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <h5>
                        Let PHX monitor your flight for you. You will receive a
                        notification when important changes have occurred to:
                    </h5>
                    {this.props.flight.AD === 'A' ? (
                        <ul>
                            <li>Flight status</li>
                            <li>Arrival time</li>
                            <li>Gate assignments</li>
                            <li>Baggage carousel information</li>
                        </ul>
                    ) : (
                        <ul>
                            <li>Flight status</li>
                            <li>Departure time</li>
                            <li>Gate assignments</li>
                        </ul>
                    )}

                    <div className='col-12'>
                        <button
                            className='btn btn-success  btn-block'
                            onClick={() => this.props.navigationFunc(true, 2)}>
                            SMS/Text Message
                        </button>
                        <button
                            className='btn btn-info  btn-block'
                            onClick={() => this.props.navigationFunc(true, 1)}>
                            E-Mail
                        </button>

                    </div>
                </Modal.Body>
                {/*<Modal.Footer>*/}
                {/*    <button*/}
                {/*        onClick={() => this.props.navigationFunc(false, 0)}*/}
                {/*        className='btn btn-secondary flbtn btn-block'>*/}
                {/*        Back*/}
                {/*    </button>*/}

                {/*</Modal.Footer>*/}
            </Modal>
        );
    }
}
